import { Injectable, OnDestroy } from "@angular/core";
import { Subject } from "rxjs";

const FINISHED_SIGNAL = 'scorm-is-finished-across-windows';

@Injectable({
  providedIn: 'root',
})
export class ScormCrossWindowService implements OnDestroy {
  private isFinishedSubject = new Subject<void>();
  public readonly isFinished$ = this.isFinishedSubject.asObservable();
  private messageListener: (event: MessageEvent) => void;

  constructor() {
    this.messageListener = (event: MessageEvent) => {
      if (event.origin === window.location.origin && event.data === FINISHED_SIGNAL) {
        this.isFinishedSubject.next();
      }
    };
    window.addEventListener('message', this.messageListener);
  }

  public finish(): void {
    if (window.opener) {
      window.opener.postMessage(FINISHED_SIGNAL, window.location.origin);
    }
  }

  ngOnDestroy(): void {
    window.removeEventListener('message', this.messageListener);
  }
}